import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const Body = styled.div`
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 11px;
  padding-bottom: 11px;
  background: #fafafa;

  ${mediaQuery.desktop`
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 40px;
  background: #fafafa;

  
  `}

  .upper {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .link {
    color: #000000;
    text-decoration: none;
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .p_name {
    margin: 0;
    color: #000000;
    font-size: 14px;
    font-weight: 600;
    white-space: nowrap;
  }
`;
export const DeliveryLocationList = styled.li`
  background-color: ${({ selected }) => (selected ? '#549a9a' : '#edfafa')};
  display: inline-block;
  padding: 4px;
  border-radius: 2px;
  box-sizing: border-box;
  font-family: Poppins;
  color: ${({ selected }) => (selected ? '#fff' : '#549a9a')};
  width: auto;
  cursor: pointer;
`;

export const DeliveryLocation = styled.ul`
  margin-top: -20px;
  padding: 0px;
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  gap: 8px;
`;

export const TopContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 11px;
  border-bottom: 1px solid #e0e0e0;

  ${mediaQuery.desktop`
  display: grid;
  grid-template-columns: repeat(2,1fr);
  gap: 80px;
  border-bottom: 1px solid #E0E0E0;
padding-bottom: 50px;
  `}

  .product_image {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  ${mediaQuery.desktop`
  .product_image {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
  `}

  .other_images {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }

  .active {
    width: 100%;
    height: 80px;
    object-fit: cover;
    cursor: pointer;
    border: 3px solid #549a9a;
    border-radius: 5px;
    paddiing: 2px;
  }

  .others {
    width: 100%;
    height: 80px;
    object-fit: cover;
    cursor: pointer;
  }

  ${mediaQuery.desktop`
  .other_images {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
  }

  .active {
    width: 80px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;
    border: 3px solid #549a9a;
    border-radius: 5px;
    paddiing: 2px;
  }

  .others {
    width: 80px;
    height: 100px;
    object-fit: cover;
    cursor: pointer;
  }
  `}

  .main_image {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  ${mediaQuery.desktop`
  .main_image {
    width: 620px;
    height: 640px;
    object-fit: cover;
  }
  `}

  .product_name {
    font-size: 16px;
    font-weight: 700;
    color: #333333;
    text-transform: capitalize;
  }

  ${mediaQuery.desktop`
  .product_name {
    font-size: 36px;
    font-weight: 700;
    color: #333333;
    text-transform: capitalize;
  }
  `}

  .product_price {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    margin-bottom: 40px;
  }

  ${mediaQuery.desktop`
  .product_price {
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    margin-bottom: 55px;
  }
  `}

  .product_description {
    font-size: 14px;
    font-weight: 400;
    line-height: 25px;
    color: #333333;
    margin-bottom: 20px;
  }

  ${mediaQuery.desktop`
  .product_description {
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
    color: #333333;
    margin-bottom: 20px;
  }
  
  `}

  .product_delivery {
    color: #333333;
    font-size: 16px;
    font-weight: 500;
  }

  button {
    margin-top: 28px;
    height: 47px;
    width: 100%;
    color: #fff;
    background-color: #549a9a;
    border: none;
    outline: none;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 500;

    &:disabled {
      opacity: 0.5;
    }
  }
`;

export const SelectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;

  ${mediaQuery.desktop`
  display: flex;
  flex-direction: row;
  align-items: center
  gap: 20px;
  `}

  .size {
    width: 100%;
  }

  .quantity_container {
    width: 208px;
    display: flex;
    flex-direction: column;
  }

  label {
    color: #333333;
    margin-bottom: 8px;
    font-szie: 16px;
    font-weight: 500;
  }

  select {
    border: 1px solid #e0e0e0;
    background: #fff;
    width: 100%;
    height: 48px;
    margin-top: 8px;
  }

  .quantity {
    width: 100%;
    margin: 0;
  }
`;

export const ProductContainer = styled.div`
  grid-column: center-start / -1;
  display: flex;
  grid-auto-flow: column;
  gap: 1rem;
  overflow: auto;
  padding-bottom: 1rem;
  scrollbar-color: #ecc94b #faf089;
  scrollbar-width: thin;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    width: 8px; /* Adjust as needed */
  }

  &::-webkit-scrollbar-thumb {
    background: #fafafa;
  }

  .card {
    width: 304px;
    text-decoration: none;
  }

  img {
    width: 100%;
    height: 304px;
    object-fit: cover;
  }

  .product_name {
    color: #000000;
    font-size: 18px;
    font-weight: 500;
    text-decoration: none;
  }

  .product_seller {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    text-decoration: none;
  }

  .product_price {
    color: #000000;
    font-size: 20px;
    font-weight: 400;
  }
`;

export const SliderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 15px;

  ${mediaQuery.desktop`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
  margin-top: 30px;
  `}

  h5 {
    margin: 0;
    color: #333333;
    font-size: 14px;
    font-weight: 700;
  }

  ${mediaQuery.desktop`
  h5 {
    margin: 0;
    color: #000000;
    font-size: 24px;
    font-weight: 700
  }
  
  `}

  aside {
    display: flex;
    gap: 20px;
    align-items: center;
  }

  ${mediaQuery.desktop`
  aside {
    display: flex;
    gap: 32px;
    align-items: center;
  }
  `}

  button {
    width: 30px;
    height: 30px;
    background: #fff;
    border: 1px solid #549a9a;
    outline: none;
    cursor: pointer;
    border-radius: 100%;
    display: grid;
    place-items: center;

    img {
      width: 100%;
      height: auto;
    }
  }

  ${mediaQuery.desktop`
  button {
    width: 56px;
    height: 56px;
    background: #fff;
    border: 1px solid #549A9A;
    outline: none;
    cursor: pointer;
    border-radius: 100%;

    img {
      width: auto;
      height: auto;
    }
  }
  `}
`;

export const TotalPrice = styled.p`
  margin: 0;
  margin-top: 20px;
  font-size: 20px;
  font-weight: 600;
`;
